import React, { useState } from 'react';
import { MdOutlineSearch } from 'react-icons/md';
import { CustomButton, CustomReactSelect } from '../../atoms';
import { toast } from 'react-toastify';
import classes from './ContentSectionDropdown.module.scss';

const ContentSectionDropdown = ({ dropdownData }) => {
    const { cta_config, data } = dropdownData;

    if (!data) return null;

    const [selectedValues, setSelectedValues] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState([data]);
    const [redirectUrl, setRedirectUrl] = useState("");

    const handleSelection = (selectedOption, context, level) => {
        if (context.action === 'clear') {
            setRedirectUrl("");
        } 

        // Update selected values up to the current level
        const updatedValues = [...selectedValues];
        updatedValues[level] = selectedOption;
        setSelectedValues(updatedValues.slice(0, level + 1));

        // Update options for the next level
        if (selectedOption?.dropdown_options) {
            const updatedOptions = [...dropdownOptions];
            updatedOptions[level + 1] = selectedOption.dropdown_options;
            setDropdownOptions(updatedOptions.slice(0, level + 2));
        } else {
            setDropdownOptions((opts) => opts.slice(0, level + 1));
            if (selectedOption?.value.startsWith("http")) {
                setRedirectUrl(selectedOption?.value);
            }
        }
    };

    const onProceedClick = () => {
        if (!redirectUrl) {
            toast.error("Something went wrong. Re-try after refreshing the page");
        }

        if (cta_config?.new_window) {
            window.open(redirectUrl, '_blank').focus();
        } else {
            window.open(redirectUrl, '_self').focus();
        }
    }

    return (
        <>
            {dropdownOptions.map((options, index) => (
                <div className={classes.FormFieldCol}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div key={`dropdown-level-${index}`}>
                                <label htmlFor={`dropdown-level-${index}`}>{options[0]?.dropdown_label} <span className="required">*</span></label>
                                <CustomReactSelect
                                    inputId={`dropdown-level-${index}`}
                                    name={`dropdown-level-${index}`}
                                    icon={<MdOutlineSearch />}
                                    maxMenuHeight={200}
                                    onChange={(e, context) => handleSelection(e, context, index)}
                                    options={options || []}
                                    value={selectedValues[index] || null}
                                    placeholder={"Select option"}
                                    noOptionsText={options.length === 0 ? "Enter 3 or more characters" : "No options"}
                                    showDisabledIcon
                                    isDisabled={false}
                                    isLoading={false}
                                    isClearable
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {redirectUrl ? (
                <div className={classes.FormFieldCol}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className={classes.FormAction}>
                                <CustomButton
                                    type="button"
                                    text={cta_config?.label || "Proceed"}
                                    // className={classes.SubmitButton}
                                    onClick={onProceedClick}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
            : null}
        </>
    );
};

export default ContentSectionDropdown;